import Button from '@/components/base/Button'
import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Schedule from '@/components/base/Schedule'
import { Tab, Tabs } from '@/components/base/Tabs'
import Typography from '@/components/base/Typography'

import { tabsInfoRevealAnimation } from './animations'
import { Section } from '@/types'

type TabsInfoProps = Section & {
  className?: string
  tabs?: []
  info: {
    features?: { title: string; text: string }[]
    description?: string
    button?: {
      title: string
      url: string
      target: string
    }
  }
}

const TabsInfo = ({ tabs, info, ...props }: TabsInfoProps) => {
  return (
    <Motion animation={tabsInfoRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-xs md:gap-y-sm">
              <div className="col-span-2 md:col-span-3 lg:col-span-7">
                <Tabs data-motion-item>
                  {tabs?.map((tab: any, index: number) => (
                    <Tab key={index} label={tab.label}>
                      <div className="mt-xs">
                        {tab.steps.length > 0 ? (
                          <Schedule key={index} steps={tab.steps} />
                        ) : null}
                      </div>
                    </Tab>
                  ))}
                </Tabs>
              </div>
              <div className="col-span-2 flex flex-col gap-y-md md:col-span-3 lg:col-span-4 lg:col-start-9">
                {info.features?.map(({ title, text }, index) => (
                  <div
                    key={`feature-${index}`}
                    className="col-span-1 md:col-span-2 lg:col-span-3"
                    data-motion-item
                  >
                    <div className="grid gap-y-sm">
                      <span className="flex">
                        <span className="relative inline-flex pb-[2rem]">
                          {title ? (
                            <Typography
                              variant="h6"
                              className="[&_em]:text-blue-soft text-blue"
                            >
                              {title}
                            </Typography>
                          ) : null}
                          <span className="bg-blue-soft absolute -bottom-[.4rem] left-0 h-[.4rem] w-full" />
                        </span>
                      </span>

                      {text ? (
                        <Typography
                          variant="body"
                          paragraph
                          className="text-neutral-20"
                        >
                          {text}
                        </Typography>
                      ) : null}
                    </div>
                  </div>
                ))}
                {info.description ? (
                  <Typography
                    variant="h4"
                    component="h3"
                    className="[&_em]:text-blue-soft mt-20 text-blue"
                    data-motion-item
                  >
                    {info.description}
                  </Typography>
                ) : null}

                {info.button ? (
                  <div data-motion-item>
                    <Button href={info.button?.url} link variant="contained">
                      {info.button?.title}
                    </Button>
                  </div>
                ) : null}
              </div>
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default TabsInfo
